/*
 * accountHealthApi — the persistent "reconnect your account" banner's data.
 *
 * Standalone module on the shared `apiClient` (the myTimeClientsApi pattern)
 * so the frozen `services/api.ts` stays untouched. Returns only the current
 * user's accounts whose token failed and needs reconnecting.
 */
import { api } from './apiClient';

export interface NeedsReconnectItem {
  provider: 'google_calendar' | 'gmail' | 'quickbooks';
  label: string;
  detail: string | null;
  reason: string;
  reconnectPath: string;
  failedAt: string | null;
}

export const accountHealthApi = {
  get: (): Promise<{ success: boolean; data: { needsReconnect: NeedsReconnectItem[] } }> =>
    api.get('/account-health').then((r) => r.data),
};
